module.exports = __webpack_public_path__ + "img/shape-metal_az@2x.a2dc1d16.png";